module.exports = __webpack_public_path__ + "media/images/icons/en-36ab476e5e55f496749ee61897a9cfb5.svg";